import { render } from "./Header.vue?vue&type=template&id=716758d2"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=716758d2&lang=scss"
script.render = render

export default script